var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16.96062469482422,
    height: 17.33333396911621,
    viewBox: "0 0 16.96062469482422 17.33333396911621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.0939,7.33948L16.4079,0L14.9116,0L9.42922,6.37277L5.05042,0L0,0L6.6216,9.63676L0,17.3333L1.49629,17.3333L7.28588,10.6035L11.9102,17.3333L16.9606,17.3333L10.0935,7.33948L10.0939,7.33948ZM8.04449,9.72166L7.37359,8.76206L2.03543,1.12639L4.33365,1.12639L8.64161,7.28862L9.31251,8.24822L14.9123,16.2582L12.6141,16.2582L8.04449,9.72203L8.04449,9.72166Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8fc331bdbab9f31d41cd3a2ecec85f46.svg";
export { ForwardRef as ReactComponent };